<div class="content-login">
    <router-outlet></router-outlet>
    <app-form-new-password></app-form-new-password>
</div>